import { createAuthClient } from "better-auth/react";
import { passkeyClient } from "@better-auth/passkey/client";
import { genericOAuthClient } from "better-auth/client/plugins";

export const authClient = createAuthClient({
  fetchOptions: { credentials: "include" },
  plugins: [passkeyClient(), genericOAuthClient()],
});
